// Shared by the permit dataProvider methods. Backend shapes:
// HTTPReactException { errors: { root: { serverError } } } or FastAPI { detail }.
export function parsePermitError(data: unknown, fallback: string): string {
    const body = data as {
        errors?: { root?: { serverError?: unknown } };
        detail?: unknown;
    } | null;
    const msg = body?.errors?.root?.serverError ?? body?.detail ?? fallback;
    return typeof msg === 'string' ? msg : fallback;
}

export type PermitSection = {
    id: number;
    municipality_id: number;
    name: string;
    created_at?: string | null;
    updated_at?: string | null;
};

export type PermitDocumentItem = {
    key: string;
    title: string;
    audience: string;
    sort_order: number;
    template_filename: string;
    permit_file_id?: number | null;
    storage_file_path?: string | null;
    section_id?: number | null;
};

export type PermitMunicipalityOption = {
    key: string;
    label: string;
};

export type PermitPackage = {
    municipality_id?: number | null;
    municipality_key: string | null;
    municipality_label: string;
    folio_number: string | null;
    folio_municipality_code: string | null;
    city: string | null;
    documents_configured: boolean;
    status_message: string | null;
    apply_description: string | null;
    active_permits_folder_path: string | null;
    primary_quote_id: number | null;
    owner_documents: PermitDocumentItem[];
    internal_documents: PermitDocumentItem[];
    sections?: PermitSection[];
    needs_municipality_selection?: boolean;
    recommended_municipality_key?: string | null;
    recommendation_reason?: string | null;
    available_municipalities?: PermitMunicipalityOption[];
};

export type PermitFileSyncResult = {
    created: number;
    linked: number;
    restored: number;
    soft_deleted: number;
};
